/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Utilizziamo i cookie semplicemente per tenere traccia delle visite sul nostro sito web. Non salviamo dati personali.',
    cookiesAccept: 'Accetta i cookie',
    cookiesDeny: 'Rifiuta i cookie',
    tabFAQs: 'FAQ',
    tabSupport: 'Assistenza',
    tabHistory: 'Storia',
    tabReviews: 'Storie',
    tabTraining: 'Formazione',
    tabUserTraining: 'Formazione utenti',
    tabHcpTraining: 'Formazione sanitari',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Gravidanza',
    tabAbout: 'Chi siamo',
    tabNews: 'Notizie',
    tabCareers: 'Lavora con noi',
    tabOrders: '',
    tabNotifications: 'Notifiche',
};
